import { render, staticRenderFns } from "./BasicSetup.vue?vue&type=template&id=d7240be6&scoped=true&"
import script from "./BasicSetup.vue?vue&type=script&lang=js&"
export * from "./BasicSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7240be6",
  null
  
)

export default component.exports